module.exports = __webpack_public_path__ + "img/Debbie_King@3x.1469511f.webp";